var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import Content from './container-content';
import InViewport from 'searchband-frontend-commons/components/context/in-viewport';
import { isSizeDefined } from '../../util';

var ContainerBlock = function (_PureComponent) {
    _inherits(ContainerBlock, _PureComponent);

    function ContainerBlock() {
        _classCallCheck(this, ContainerBlock);

        return _possibleConstructorReturn(this, (ContainerBlock.__proto__ || Object.getPrototypeOf(ContainerBlock)).apply(this, arguments));
    }

    _createClass(ContainerBlock, [{
        key: 'render',
        value: function render() {
            var props = this.props;

            var isSizeDefined = this.isSizeDefined;

            return React.createElement(
                InViewport.Consumer,
                null,
                function (inViewport) {
                    return React.createElement(Content, _extends({}, props, {
                        renderChildren: inViewport || !isSizeDefined
                    }));
                }
            );
        }
    }, {
        key: 'isSizeDefined',
        get: function get() {
            var props = this.props;


            return isSizeDefined(props.width) && isSizeDefined(props.height);
        }
    }]);

    return ContainerBlock;
}(PureComponent);

export default ContainerBlock;